export enum EIremboFormlyFormStateKeys {
  FETCHED_DATA = 'FETCHED_DATA',
  FETCHED_OPTIONS_DATA = 'FETCHED_OPTIONS_DATA',
  FETCHED_COLUMNS_DATA = 'FETCHED_COLUMNS_DATA',
  FETCHED_METADATA = 'FETCHED_METADATA',
  APPLICATION_STATE = 'APPLICATION_STATE',
  RFA_FLAGGED_FIELDS = 'RFA_FLAGGED_FIELDS',
  JOURNEY_FEEDBACKS = 'JOURNEY_FEEDBACKS',
  ALLOW_EDITING_ALL_FIELDS = 'ALLOW_EDITING_ALL_FIELDS',
  APPLICANT_BUSINESS_NAME = 'APPLICANT_BUSINESS_NAME',
  APPLICANT_BUSINESS_ID = 'APPLICANT_BUSINESS_ID',
  APPLICANT_TYPE = 'APPLICANT_TYPE',
  LOCALE = 'LOCALE',
  APPLICANT_USER_ID = 'APPLICANT_USER_ID',
}
